import { FC, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Cookies } from '../components/cookies/cookies'
import { Footer } from '../components/footer/footer'
import { Navbar } from '../components/navbar/navbar'

export const AppLayout: FC = () => {
  const [showBanner, setShowBanner] = useState(true)
  const location = useLocation()
  const isOfferCheckout = location.pathname === '/offer-checkout'

  return (
    <main className='flex min-h-screen w-screen flex-col bg-[#1b1f54] bg-background bg-center'>
      <img
        className={`absolute ${isOfferCheckout ? 'hidden' : ''}`}
        src='/assets/background-gradient.png'
        alt='background-gradient'
      />
      <Navbar />
      <Cookies
        showBanner={showBanner}
        setShowBanner={setShowBanner}
      />
      <main className='flex min-h-[640px] flex-1 pb-10'>
        <Outlet />
      </main>
      <Footer setShowBanner={setShowBanner} />
    </main>
  )
}
